export enum SpecialLinks {
  OutletShop = 'OutletShop',
  JoinRewards = 'JoinRewards',
  RewardsShop = 'RewardsShop',
  SampleShop = 'SampleShop',
  New = 'New',
}

export enum SpecialLinksOrder {
  New,
  SampleShop,
  OutletShop,
  RewardsShop,
  JoinRewards,
}

export declare type SpecialLinksType = keyof typeof SpecialLinksOrder;
